import { call, put, select, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";
import {
    IS_CONNECTED_POS,
    onIsConnectedPOSSuccess,
    onIsConnectedPOSFail,
    POS_CONNECTION,
    onPOSConnectionSuccess,
    onPOSConnectionFail,
    UPLOAD_MENUS_FROM_POS,
    onUploadMenusFromPOSSuccess,
    onUploadMenusFromPOSFail,
    ALLERGENS_SAVE_IN_MENU,
    onAllergensSaveInMenuSuccess,
    onAllergensSaveInMenuFail,
    NEW_MENU_LOAD,
    onNewMenuLoadSuccess,
    onNewMenuLoadFail,
    MENU_LOAD,
    onMenuLoadSuccess,
    onMenuLoadFail,
    MENU_NEW_SAVE,
    onMenuNewSaveSuccess,
    onMenuNewSaveFail,
    onMenuUpdateSuccess,
    onMenuUpdateFail,
    MENU_UPDATE,
    ARCHIVE_MENU,
    onArchiveMenuSuccess,
    onArchiveMenuFail,
} from "./actions";
import { allergensSave, getIsConnectedPos, getMenu, getMenusFromPOS, getNewMenu, getPosConnection, menuArchivate, menuUpdate, newMenuSave} from "./api";

function* isConnectedPosWorker(action) {
    try {
        const response = yield call(getIsConnectedPos,action.restId);
        yield put(onIsConnectedPOSSuccess(response));
    } catch (e) {
        yield put(onIsConnectedPOSFail(e));
    }
}

function* posConnectionWorker(action) {
    try {
        const response = yield call(getPosConnection,action.restId);
        yield put(onPOSConnectionSuccess(response));
    } catch (e) {
        yield put(onPOSConnectionFail(e));
    }
}

function* uploadMenuWorker(action) {
    try {
        const response = yield call(getMenusFromPOS,action.restId);
        yield put(onUploadMenusFromPOSSuccess(response));
    } catch (e) {
        yield put(onUploadMenusFromPOSFail(e));
    }
}

function* allergensSaveWorker(action) {
    try {
        const response = yield call(allergensSave, action.allergens);
        yield put(onAllergensSaveInMenuSuccess(response));
    } catch (e) {
        yield put(onAllergensSaveInMenuFail(e));
    }
}

function* newMenuLoadWorker() {
    try {
        const response = yield call(getNewMenu);
        yield put(onNewMenuLoadSuccess(response));
    } catch (e) {
        yield put(onNewMenuLoadFail(e));
    }
}

function* menuLoadWorker(action) {
    try {
        const response = yield call(getMenu, action.restId);
        yield put(onMenuLoadSuccess(response));
    } catch (e) {
        yield put(onMenuLoadFail(e));
    }
}

function* menuNewSaveWorker(action) {
    try {
        const response = yield call(newMenuSave, action.values, action.selected, action.isCheckAllFutureLocations);
        yield put(onMenuNewSaveSuccess(response));
    } catch (e) {
        yield put(onMenuNewSaveFail(e));
    }
}

function* menuUpdateWorker(action) {
    try {
        const response = yield call(
            menuUpdate,
            action.restId,
            action.values,
            action.selected,
            action.isCheckAllFutureLocations
        );
        yield put(onMenuUpdateSuccess(response));
    } catch (e) {
        yield put(onMenuUpdateFail(e));
    }
}

function* menuArchiveWorker(action) {
    try {
        const response = yield call(menuArchivate, action.archived, action.menuId);
        yield put(onArchiveMenuSuccess(response));
    } catch (e) {
        yield put(onArchiveMenuFail(e));
    }
}

function* menuSaga() {
    yield takeEvery(IS_CONNECTED_POS, isConnectedPosWorker);
    yield takeEvery(POS_CONNECTION, posConnectionWorker);
    yield takeEvery(UPLOAD_MENUS_FROM_POS, uploadMenuWorker);
    yield takeEvery(ALLERGENS_SAVE_IN_MENU, allergensSaveWorker);
    yield takeEvery(NEW_MENU_LOAD, newMenuLoadWorker);
    yield takeEvery(MENU_LOAD, menuLoadWorker);
    yield takeEvery(MENU_NEW_SAVE, menuNewSaveWorker);
    yield takeEvery(MENU_UPDATE, menuUpdateWorker);
    yield takeEvery(ARCHIVE_MENU, menuArchiveWorker);
}

export default menuSaga;
